/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    global: {
        ':where(*, *::before, *::after)': {
            wordWrap: 'normal'
        },
        'html, body': {
            backgroundColor: 'white',
            color: 'black'
        },
        body: {
            minHeight: '100vh'
        },
        'b, strong': {
            fontWeight: 'medium'
        },
        blockquote: {
            margin: 'revert'
        },
        'ul, ol': {
            padding: 'revert'
        },
        '.react-target': {
            display: 'flex',
            minHeight: '100vh'
        },
        '.decorationLine': {
            height: '3px',
            background: 'linear-gradient(90deg, rgba(254,163,11,1) 0%, rgba(254,163,11,0) 100%)',
            width: '80px',
            marginBottom: '1rem'
        },
        '.menuLinkActive': {
            /*
            for strange reasons, we need to define this style via a class.
            when defined in the list-menu theme, where it should belong, chakra-ui adds it as an inline-style which doesn't work.
            */
            borderImage:
                'linear-gradient(90deg, rgba(254, 163, 11, 0) 0%, rgba(254, 163, 11, 1) 50%, rgba(254, 163, 11, 0) 100%) 1'
        },
        /* Global vertical spacing behaviour for page-designer components */
        '.component:not(:last-of-type)': {
            marginBottom: {base: '3rem', md: '4rem', xl: '5rem'}
        },
        '.component .component': {
            marginBottom: '0'
        },
        /* Global horizontal spacing behaviour for page-designer components */
        '.pdcFullWidth': {
            padding: 0
        },
        '.pdcOuterBox:not(.pdcFullWidth)': {
            px: [4, 4, 6, 6, 8, 0],
            paddingTop: 0,
            paddingBottom: 0,
            width: '100%',
            maxWidth: 'container.xxxl',
            marginLeft: 'auto',
            marginRight: 'auto'
        },
        '.sf-product-detail-page .pdcOuterBox': {
            px: 0
        },
        /* customize wrapping behaviour for layout component 'mobile-3r-1c' (used for app-section) on tablets  */
        '.mobile-3r-1c #column1': {
            gridArea: {base: 'unset', sm: 'col1', xl: 'unset'}
        },
        '.mobile-3r-1c #column2': {
            gridArea: {base: 'unset', sm: 'col2', xl: 'unset'}
        },
        '.mobile-3r-1c #column3': {
            gridArea: {base: 'unset', sm: 'col3', xl: 'unset'}
        },
        '.mobile-3r-1c': {
            gridTemplateAreas: {base: 'initial', sm: `"col1 col1" "col2 col3"`, xl: 'inherit'}
        },
        '.dataSlidesVideo': {
            objectPosition: {base: 'bottom', lg: 'bottom right', xl: 0}
        }
    }
}
